export const Check = () => (
  <svg
    width="84"
    height="84"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.4436 70.5561C29.2148 86.3273 54.7849 86.3273 70.5561 70.5561C86.3273 54.7849 86.3273 29.2148 70.5561 13.4436C54.7849 -2.32756 29.2148 -2.32756 13.4436 13.4436C1.03899 25.8482 -1.60893 44.3149 5.49985 59.3075M24.6922 43.4422L36.2306 54.9806L62.0472 30.6063"
      stroke="#42BE65"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
)
